var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 118,
    viewBox: "0 0 125 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.576172 45.3857L56.497 2.05512C60.0304 -0.68504 64.9699 -0.68504 68.5033 2.05512L124.424 45.3857V118H0.576172V45.3857Z",
    fill: "#38C5AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4651 31.1035H82.0094C84.4518 31.1035 86.4345 33.0862 86.4345 35.5286V97.9177C86.4345 100.36 84.4518 102.343 82.0094 102.343H36.4651C34.0227 102.343 32.04 100.36 32.04 97.9177V35.5286C32.04 33.0862 34.0227 31.1035 36.4651 31.1035Z",
    fill: "#FAFAFA",
    stroke: "#30426D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9204 81.2855L1 45V117.571L62.9204 81.2855Z",
    fill: "#90DACE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77 31H74V80H77V31Z",
    fill: "#30426D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9204 81.2855L124.848 45V117.571L62.9204 81.2855Z",
    fill: "#90DACE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.497 74.6694L0.576172 118H124.424L68.5033 74.6694C64.9699 71.9292 60.0304 71.9292 56.497 74.6694Z",
    fill: "#4CC3B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopGreen);
export default __webpack_public_path__ + "static/media/envelop-green.3c0073bef3fb9edcbcf1d6077ea4ba94.svg";
export { ForwardRef as ReactComponent };